// extracted by mini-css-extract-plugin
export default {"accountDropdownWrapper":"AccountDropdown_accountDropdownWrapper__zzIbv","clientLogo":"AccountDropdown_clientLogo__5aZne","accountDropdown":"AccountDropdown_accountDropdown__eOR5X"};